import { createAction } from 'redux-actions';

export const clearReservationExportUrl = createAction(
  'CLEAR_RESERVATION_EXPORT_URL'
);

export const setReservationExportInProgress = createAction(
  'SET_RESERVATION_EXPORT_IN_PROGRESS'
);
